import { render } from "./SharingSetting.vue?vue&type=template&id=996e2134&scoped=true&ts=true"
import script from "./SharingSetting.vue?vue&type=script&lang=ts"
export * from "./SharingSetting.vue?vue&type=script&lang=ts"

import "./SharingSetting.vue?vue&type=style&index=0&id=996e2134&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996e2134"]])

export default __exports__